import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { ReactElement } from "react";
import {
  AppPrimaryButton,
  AppSecondaryButton,
} from "shared/components/AppComponents";
import { CloseDialogIcon } from "assets/styles/icons";
import { AuthActions } from "state/auth/Action";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ProgressActions } from "state/progress/Action";
import { sblProgressState } from "state/progress/Reducer";
import { ProfileActions } from "state/profile/Action";
import { profileState } from "state/profile/Reducer";
import { useProgress } from "context/ProgressProvider";

const ThankYouDialog = (props: any): ReactElement => {
  const { showConfirm, onCloseForm } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isBroker } = useProgress();

  const actionOnLogout = (): void => {
    const resetStorage = new Promise((resolve, reject) => {
      dispatch(AuthActions.resetStore({}));
      resolve(true);
    });
    resetStorage.then(() => {
      if (isBroker) {
        navigate("/broker");
      } else {
        navigate("/sbl");
      }
    });
  };

  return (
    <>
      <Dialog
        open={showConfirm !== ""}
        fullWidth
        maxWidth="sm"
        // className="account-dailog-wrapper"
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h2">Thank You</Typography>
            <IconButton onClick={onCloseForm}>
              <CloseDialogIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" className="f16">
            {showConfirm === "physical" && (
              <>
                Before continuing make sure you have emailed us the signed
                documents and don't forget to toggle YES on 'Mail' tab
              </>
            )}
            {showConfirm === "progress" && (
              <>
                Thanks for sending the documents. We’ll review them soon and may
                reach out for any additional documents needed to process your
                loan application.
              </>
            )}
          </Typography>
        </DialogContent>

        <DialogActions className="p-6">
          <AppSecondaryButton
            title="Cancel"
            className="btn-small"
            onClick={onCloseForm}
          />
          <AppPrimaryButton
            title="Logout"
            className="btn-small"
            onClick={actionOnLogout}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ThankYouDialog;
